Shopify.upsell = async function (items, options = {}) {
  const { updates, formData } = items;
  const { note, attributes, eventData = {} } = options;
  const cartDrawer = document.querySelector('cart-drawer');

  let addedProduct = formData;
  let data = {};
  const updateResponse = await fetch(Shopify.routes.root + 'cart/update.js', {
    ...fetchConfig(),
    body: JSON.stringify({
      updates,
      note,
      attributes,
      sections: cartDrawer?.getSectionsToRender().map((section) => section.id) || [],
      sections_url: window.location.pathname,
    }),
  });
  data.update = await updateResponse.json();

  if (typeof addedProduct === 'string') {
    addedProduct = [{ id: variants }];
  }
  const addResponse = await fetch(Shopify.routes.root + 'cart/add.js', {
    ...fetchConfig(),
    body: JSON.stringify({
      items: addedProduct,
      sections: cartDrawer?.getSectionsToRender().map((section) => section.id) || [],
      sections_url: window.location.pathname,
    }),
  });
  if (addResponse.status) {
  }
  data.add = await addResponse.json();

  if (cartDrawer) {
    cartDrawer.renderContents(data.add, true);
  }

  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'shopify',
    productVariantId: addedProduct,
    ...eventData,
  });

  return data;
}

function attachUpsellListeners() {
  const upsellButtons = document.querySelectorAll(".CartItem__Upsell--Action button");
  upsellButtons.forEach(button => {
    
    button.addEventListener("click", e => {
      const upsell = e.currentTarget.closest(".CartItem__Upsell");
      const quantity = Number(upsell.dataset.upsellQty);
      const variant = Number(upsell.dataset.upsellId);
      const planId = Number(upsell.dataset.planId);
      const initialPrice = Number(upsell.dataset.initialPrice);
      const finalPrice= Number(upsell.dataset.finalPrice);
      const itemKey = upsell.dataset.itemKey;
      const originalOffer = upsell.dataset.originalOffer;
      const extKey = upsell.dataset.extKey;
      const extQty = Number(upsell.dataset.extQty);

      // Data to update 
      let updates = {
        [itemKey]: 0 
      }

      let options = {
        attributes: {
          '__upsell': 'true'
        }
      };
      
      if (extQty !== 0) {
        updates[extKey] = 0;
      };

      // Data to add 
      let formData = [{
        'id': variant,
        'quantity': quantity + extQty,
        'properties': {
          '_original_offer': originalOffer,
          '_price_increase': finalPrice - initialPrice,
          '_final_price': finalPrice
        }
      }];

      if (planId !== 0) {
        formData[0].selling_plan = planId;
      }

      Shopify.upsell({ updates, formData }, options);
    })
  
  })
}

window.addEventListener("delayedLoad", e => {
  attachUpsellListeners();
  const observer = new MutationObserver(attachUpsellListeners);

  observer.observe(document.querySelector("cart-drawer"), {
    subtree: true,
    childList: true,
  });
})